export default "__VITE_ASSET__CSHmrro8__"